module.exports = __webpack_public_path__ + "img/LUCIA_120X35.69609efa.png";